export default {
    //英语
    DiagnosticReport:'Diagnostic report',
    troubleCode:'Fault code',
    time:'time',
    noTItle:'Manufacturer control',
    TestReport:'Test Report',
    VehicleInformation:'Vehicle Information',
    DataStream:'Data stream',
    IMReadiness:'I/M Readiness',
    Communication:'Communication protocol',
    notFaultCode:'No fault code',
    nodataflow:'No abnormal data flow',
    PositioningPrompt:'Enable the location function to obtain local prices',
    FaultCode:'Fault code',
    AIDiagnosis:'AI diagnosis',
    AIWait:'AI report or wait for automatic diagnosis',
    FailedFaultCode:'Unable to obtain fault code information',
    AIError:'AI analysis failure',
    more:'more',
    StoredCodes:'Stored Codes',
    PendingCodes:'Pending Codes',
    PermanentCodes:'Permanent Codes',
    ManufacturerControl:'Manufacturer control',
    continue:'continue',
    // 引导定位
    notlimits:'Unable to obtain location permission',
    setupSteps:'Setup steps:',
    openset:'Open the "Settings" app',
    findSet:'Find the app you are using',
    clickset:'Click "Location"',
    selectLimits:'Choose "During use" or "Always"',
    blackRefresh:'Return to the application refresh page',
    openAppSet:'Click "Application Management" or "Application"',
    findUseBrowser:'Find the browser you are using',
    clickAuthority:'Click "Permission Management"',
    findejurisd:'Find "location" permission',
    selectjurisd:'Choose "Allow" or "Allow when used"',
    phoneJurisd:'Check the location permission of the mobile app:',
    openJurisd:'Enable "Location" permission',
    report:'Report',
    AI:'AI'
}